import { ReactNode } from 'react';

import classNames from 'classnames';

import { DynamicalStyles } from '@consts';

interface ScrollableAreaProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  className?: string;
}

export default function ScrollableArea({
  children,
  className = '',
  ...props
}: ScrollableAreaProps) {
  return (
    <div
      {...props}
      className={classNames(
        'flex flex-col flex-1 min-h-0 overflow-auto',
        DynamicalStyles.scrollbarStyles(),
        className
      )}
    >
      {children}
    </div>
  );
}
